import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { CurrencyInfo } from '@/core/currency/interfaces';
import { formatCurrency } from '@/core/currency/helpers';
import { LoyaltyInfo } from '@/core/payment-card/interfaces';
import { LoyaltySelectItem } from './interfaces';

@Component({
    data() {
        return {
            selectedValue: null
        };
    }
})
export default class LoyaltySelect extends Vue {
    @Prop(Number)
    value: number;

    @Prop(Object)
    currency: CurrencyInfo;

    @Prop(Object)
    loyaltyInfo: LoyaltyInfo;

    selectedValue: number;

    mounted() {
        this.selectedValue = this.value;
    }

    get loyaltyItems() {
        if (!this.loyaltyInfo) {
            return [];
        }

        const {
            pointsToAmountRate,
            maxRedemptionPoints,
            maxRedemptionAmount,
            minRedemptionAmount,
            redemptionAmountStep
        } = this.loyaltyInfo;

        const step = redemptionAmountStep * 100;
        const loyaltyItems: Array<LoyaltySelectItem> = [];

        if (pointsToAmountRate) {
            for (let i = minRedemptionAmount; i <= maxRedemptionAmount; i += step) {
                loyaltyItems.push({
                    amount: i,
                    points: i / pointsToAmountRate
                });
            }
        }

        if (maxRedemptionPoints && maxRedemptionPoints % step !== 0) {
            loyaltyItems.push({
                amount: maxRedemptionAmount,
                points: maxRedemptionPoints * 100
            });
        }

        return loyaltyItems.reverse();
    }

    @Watch('selectedValue')
    onChangeSelectedValue(value) {
        this.$emit('input', value);
    }

    @Watch('value')
    onChangeValue() {
        this.selectedValue = this.value;
    }

    format(value: number, format: string) {
        return formatCurrency(
            value || '0',
            this.currency?.format,
            format
        );
    }
}
